import { createContext, useContext, useState } from 'react'
import type { ReactNode } from 'react'

type BackOverride = { goBack: () => void } | null

type FlowBackOverrideContextType = {
  backOverride: BackOverride
  setBackOverride: (override: BackOverride) => void
}

export const FlowBackOverrideContext =
  createContext<FlowBackOverrideContextType>({
    backOverride: null,
    setBackOverride: () => {},
  })

export const FlowBackOverrideProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [backOverride, setBackOverride] = useState<BackOverride>(null)

  return (
    <FlowBackOverrideContext.Provider value={{ backOverride, setBackOverride }}>
      {children}
    </FlowBackOverrideContext.Provider>
  )
}

export const useFlowBackOverride = () => useContext(FlowBackOverrideContext)
